import { render, staticRenderFns } from "./Notesbar.vue?vue&type=template&id=7ff5e584&scoped=true&"
import script from "./Notesbar.vue?vue&type=script&lang=js&"
export * from "./Notesbar.vue?vue&type=script&lang=js&"
import style0 from "./Notesbar.vue?vue&type=style&index=0&id=7ff5e584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff5e584",
  null
  
)

export default component.exports